import { render } from "./UserEmailDialog.vue?vue&type=template&id=49fda794&scoped=true"
import script from "./UserEmailDialog.vue?vue&type=script&lang=js"
export * from "./UserEmailDialog.vue?vue&type=script&lang=js"

import "./UserEmailDialog.vue?vue&type=style&index=0&id=49fda794&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49fda794"]])

export default __exports__